import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getUsersList = createAsyncThunk(
    "usersList/getUsersList",
    async ({ token ,offset,limit}, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/admin/platform-users`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params:{
                        offset,limit
                    }
                }
            );
            if (response.data.status) {
                return {offset,response:response.data.response};
            } else {
                return rejectWithValue("Failed to fetch ");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || "Unknown error");
        }
    }
);

const usersListSlice = createSlice({
    name: "usersList",
    initialState: {
        usersList: [],
        isLoading: false,
        isError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUsersList.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(getUsersList.fulfilled, (state, action) => {
                if (action.payload.offset === 1) {
                    state.usersList = action.payload.response

                } else {
                    state.usersList = [...state.usersList, ...action.payload.response]

                }
            })
            .addCase(getUsersList.rejected, (state, action) => {
                state.isLoading = false;
               
            
            })
    },
});

export default usersListSlice.reducer;
